import jwt_decode from "jwt-decode";

export const TOKEN_KEY = "@User:token";
export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;
export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const isGenericaToken = () => {
  if (isAuthenticated()) {
    const decoded = jwt_decode(getToken());
    return decoded.providers !== undefined;
  } else return false;
};

export const isTokenExpired = () => {
  const token = getToken();
  if (!token) {
    return null;
  }

  const decoded = jwt_decode(getToken());

  var tokenExpiry = decoded.exp * 1000;

  return new Date() > tokenExpiry;
};

export const login = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};
